const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMglassBars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M43 589v-5h11v5H43Zm10-4h-9v3h9v-3Zm-10-9h11v5H43v-5Zm1 4h9v-3h-9v3Zm-1-12h11v5H43v-5Zm1 4h9v-3h-9v3Zm-3.086 11.621-2.766-2.766a5.056 5.056 0 1 1 .707-.707l2.766 2.766ZM39 577a4.041 4.041 0 1 0-1.559 3.148l-.062-.062.707-.708.062.063A3.962 3.962 0 0 0 39 577Z",
    transform: "translate(-30 -568)",
    style: {
      fill: "#26282d",
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMglassBars);
export default __webpack_public_path__ + "static/media/mglassBars.9cc8aa6f7e5047c05fb13d3c6d5ed9ab.svg";
export { ForwardRef as ReactComponent };